import React from "react";
import { Redirect, Switch, useLocation } from "react-router-dom";
import { accessTokenCookieKey, getCookies, refreshTokenCookieKey } from "../API/cookies";

import { PageLayout } from "../components/Layout";
import { Vehicle } from "../views";
import PermissionedRoute from "./PermissionedRoute";

const VehicleRouter = () => {
  const location = useLocation();
  const background = location?.state?.background || location;

  if (!getCookies(accessTokenCookieKey) && !getCookies(refreshTokenCookieKey))
    return <Redirect to={{ pathname: "/logout", state: { from: location.pathname } }} />;

  return (
    <>
      <Switch location={background || location}>
        <PermissionedRoute permission={Permissions.readVehicles} exact path="/vehicles">
          <PageLayout>
            <Vehicle />
          </PageLayout>
        </PermissionedRoute>
      </Switch>
    </>
  );
};

export default VehicleRouter;
